/**
 * @license
 * Copyright (c) 2025 Handsoncode. All rights reserved.
 */
import enGB from "./enGB.mjs";
const dictionary = Object.assign(Object.assign({}, enGB), {
  langCode: 'enUS'
});
export default dictionary;